import React, { useState } from 'react'
import { MDBBtn } from 'mdb-react-ui-kit'
import './AwardingTodayBtn.scss'
import UserProfileService from '../../../shared/services/UserProfile.service'

export const RecognizeAgentBtn = ({ User, Accomplishment }) => {
  const [loading, setLoading] = useState(false)

  if (!User || !Accomplishment) return <></>

  return (
    <MDBBtn
      color='indigo'
      className='awarding-today-btn'
      disabled={loading || !Accomplishment?.get('accomplished_at') || Accomplishment?.isRecognized()}
      onClick={async () => {
        if (Accomplishment?.isRecognized() === false) {
          setLoading(true)
          await Accomplishment.recognize({
            recognized_by: UserProfileService.getUserId(true),
          })
          setLoading(false)
        }
      }}
    >
      {Accomplishment?.isRecognized() === true ? (
        'Awarded'
      ) : loading ? (
        <>
          <i className='fa fa-spin fa-spinner' />
          &nbsp;Awarding
        </>
      ) : (
        <>Awarding Today</>
      )}
    </MDBBtn>
  )
}
